import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="none"
					image={require('./image.jpg')}
					title={"The Darth Vader Guide to Bad Management"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle david"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>David</strong> on Jun 20 2016  //  Posted in <strong>Marketing, Advertising</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
									The Darth Vader Guide to Bad Management
								</div>
								
								<p>In Darth Vader, we find the archetype of evil, the quintessential villain, the fearsome adversary we love to hate; the ultimate baddie. The lightsaber-wielding antagonist also shows us what not to do if we want success in business. Let us pause to examine Darth’s modus operandi so we can learn from his shortcomings:</p>

							

							
								<ul className="with-icons">
									<li>
									He always makes an entrance complete with heavy-booted marching, dramatic cape-swishing and his own foreboding theme song. Sometimes, however, it is beneficial to be the fly on the wall, silently observing the workplace and noting what goes on when others think you are not there.
									</li>
									<li>
									He stands over his workers, heavy-breathing down their necks. It is very difficult for staff to do their best work under such close supervision – show a little faith and allow workers to take responsibility, show initiative and rise to the occasion.
									</li>
									<li>
									He chokes those who say what he doesn’t want to hear. In fact, it can be most enlightening to listen to and consider points of view other than your own.
									</li>
									<li>
									He cannot be trusted to keep his word. Fair go, mate; a promise is a promise and staff must be able to believe their boss.
									</li>
									<li>
									He kills off pretty much anyone who annoys him. Great for short-term gratification, but not for long-term reputation. In a labour shortage situation, such ruthlessness will leave him desperately short-staffed and unable to meet market demands.
									</li>
									<li>
									He alters the terms of agreements after they have been made. This could result in hefty legal bills as well as losing significant (surviving) business partners.
									</li>
									<li>
									He is over-confident, often usurping his superiors’ authority. No one likes a smarty pants and disrespectful employees are less likely to be promoted regardless of their talents.
									</li>
									<li>
									He is pompous and rude. Nobody makes friends and influences people that way – expand networks, don’t burn bridges.
									</li>
									<li>
									He does not sufficiently protect his Intellectual Property (IP). Although nobody seems to be pointing the finger at Vader, since he is sent to retrieve them, one suspects the Rebels were able to steal the plans to the Death Star due to his negligence. One cannot blame an opportunistic thief for nabbing brilliant IP if it is not kept secure.
									</li>
									<li>
									He wastes valuable resources. The Empire’s extremely expensive ultimate weapon, the Death Star, was put out of action in no time, destroyed by just a small band of Rebels. If you are going to invest in an expensive piece of equipment, make sure you are getting the right item for the job, keep it in good working order, take out insurance, train staff how to use it properly and protect it from attack.
									</li>
									<li>He has no family or friends. Maintaining a healthy and rewarding work-life balance is the sine qua non, the essential ingredient in any sustainable Empire building.</li>
								</ul>

								<p>It should not be forgotten, however, that Vader was once the promising young star among the Jedi Knights, so like all bad bosses he has some good in him somewhere. He does get a few things right, including:</p>

								<ul className="with-icons">
									<li>At the beginning of Episode V we learn that Vader has become obsessed with hunting down Luke Skywalker using the entire Imperial fleet. Headhunting is indeed a valid form of recruiting quality staff (even if obsession is inadvisable).</li>
									<li>When he captures Skywalker, we realise Vader’s plan is to entice his son to become his apprentice and eventually his replacement. Every good entrepreneur needs to have a succession plan.</li>
									<li>He does his own dirty work. Effective managers need to take the good with the bad, chip in and get their hands dirty when times are tough, and do the firing as well as the hiring.</li>
									<li>He is well-spoken, impeccably dressed and unforgettable. First impressions count and as the manager sets the standard for their workers, a professional yet uniquely individual appearance and demeanour goes a long way.</li>
									<li>He is hard-working, ambitious and doesn’t give up. In spite of his many managerial shortcomings, Vader does rise up through the ranks and is the boss’s pet.</li>
								</ul>

								<p>Everyone’s favourite on film, there are few who would want Darth Vader as a boss. Ask yourself if you have any Vaderesque qualities that could be counterproductive to success in your workplace, and in business as in life, may The Force be with you!</p>

							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/DarthVader/index.js